// partnerNetwork.ts — MCC intelligence. The referral / lender-partner tracker
// client (F25/F45/F56): a partner directory over the real cohorts + an audited
// edge-capture flow (referral / financing / title / co_marketing).

import { request } from './request'

export interface PartnerRow {
  profile_id: string
  name: string
  email: string | null
  phone: string | null
  lifecycle_stage: string
  company: string | null
  referrals_sent: number
  referrals_converted: number
  conversion_rate: number | null
  financed_projects: number
  title_projects: number
  co_marketing_count: number
  total_edges: number
  last_edge_at: string | null
}

export interface PartnerEdge {
  id: string
  edge_type: string
  status: string
  occurred_at: string | null
  source_channel: string | null
  notes: string | null
  fee_amount_cents: number | null
  fee_status: string | null
  subject_profile_id: string | null
  subject_lead_id: string | null
  project_id: string | null
  subject_label: string
  project_name: string | null
}

export interface RecordEdgeInput {
  partner_profile_id: string
  edge_type: 'referral' | 'financing' | 'title' | 'co_marketing'
  subject_profile_id?: string
  subject_lead_id?: string
  project_id?: string
  occurred_at?: string
  source_channel?: string
  notes?: string
  fee_amount_cents?: number
  fee_status?: string
}

export const partnerNetworkApi = {
  list: (filters: { type?: string; has_activity?: boolean; search?: string } = {}) => {
    const p = new URLSearchParams()
    if (filters.type) p.set('type', filters.type)
    if (filters.has_activity) p.set('has_activity', '1')
    if (filters.search) p.set('search', filters.search)
    const qs = p.toString()
    return request<{
      ok: boolean
      type: string
      partners: PartnerRow[]
      total: number
      total_with_activity: number
      cohort_missing?: boolean
    }>(`/api/admin/partner-network${qs ? `?${qs}` : ''}`)
  },

  partner: (profileId: string) =>
    request<{ ok: boolean; partner: Record<string, unknown>; edges: PartnerEdge[] }>(
      `/api/admin/partner-network/${encodeURIComponent(profileId)}`,
    ),

  recordEdge: (body: RecordEdgeInput) =>
    request<{ ok: boolean; id: string; deduped?: boolean; referrer_spine_set?: boolean; referrer_spine_conflict?: boolean }>(
      '/api/admin/partner-network/edges',
      { method: 'POST', body: JSON.stringify(body) },
    ),

  updateEdge: (id: string, body: { status?: string; fee_amount_cents?: number | null; fee_status?: string | null; notes?: string | null }) =>
    request<{ ok: boolean; id: string }>(`/api/admin/partner-network/edges/${encodeURIComponent(id)}`, {
      method: 'PATCH',
      body: JSON.stringify(body),
    }),
}
